import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "status_draft": {
        id: 'invoice.status_selection.status_draft',
        defaultMessage: 'Draft',
    },
    "status_sent": {
        id: 'invoice.status_selection.status_sent',
        defaultMessage: 'Sent',
    },
    "status_partially_paid": {
        id: 'quote.status_selection.status_partially_paid',
        defaultMessage: 'Partially paid',
    },
    "status_fully_paid": {
        id: 'quote.status_selection.status_fully_paid',
        defaultMessage: 'Fully paid',
    },
    "status_active": {
        id: 'quote.status_selection.status_active',
        defaultMessage: 'Active',
    },
    "status_inactive": {
        id: 'quote.status_selection.status_inactive',
        defaultMessage: 'Inactive',
    },
    "status_finished": {
        id: 'quote.status_selection.status_finished',
        defaultMessage: 'Finished',
    },
    "status_voided": {
        id: 'quote.status_selection.status_voided',
        defaultMessage: 'Voided',
    },
})

class InvoiceStatusSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            multi: this.props.multi || false,
            recurring: this.props.recurring || false,
            selectedOptions: this.props.value || []
        }
        let optionsArray = [
            {
                value: 'draft',
                label: this.props.intl.formatMessage(messages["status_draft"])
            },
            {
                value: 'sent',
                label: this.props.intl.formatMessage(messages["status_sent"])
            },
            {
                value: 'partially-paid',
                label: this.props.intl.formatMessage(messages["status_partially_paid"])
            },
            {
                value: 'fully-paid',
                label: this.props.intl.formatMessage(messages["status_fully_paid"])
            },
        ]
        if (!this.props.isReturn) {
            optionsArray.push({
                value: 'voided',
                label: this.props.intl.formatMessage(messages["status_voided"])
            })
        }
        if (this.state.recurring) {
            optionsArray = [
                {
                    value: 'draft',
                    label: this.props.intl.formatMessage(messages["status_draft"])
                },
                {
                    value: 'active',
                    label: this.props.intl.formatMessage(messages["status_active"])
                },
                {
                    value: 'inactive',
                    label: this.props.intl.formatMessage(messages["status_inactive"])
                },
                {
                    value: 'finished',
                    label: this.props.intl.formatMessage(messages["status_finished"])
                },
            ]
        }

        this.state.options=optionsArray
        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOptions: selectedOption
        }, () => {
            if (selectedOption) {
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            } else {
                this.onChange("", "")
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(InvoiceStatusSelect)





// WEBPACK FOOTER //
// ./src/invoice/statusesselection.component.jsx